import React, { useState, useEffect } from 'react';
import CellEditable from '../containers/CellEditable';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
} from '@material-ui/core';
import FiltersVat from './Filters/FiltersVat';
import ReactTable from 'react-table';
import '../sass/dataExport.css';
import Filters from './Filters/Filters';
import CallApi from '../../../utils/CallApi';
import { I18n } from 'react-redux-i18n';
import { addFlashMessage } from '../../../common/flashMessage/actions/flashMessages';
import { connect } from 'react-redux';
import { ACCOUNT_TYPES } from '../containers/NewVatSettings';

function AccountsHandler({
	floors,
	contacts,
	onCreate,
	addFlashMessage,
	cashbackPaymentTypes,
	initialAccType,
	// asModal : même formulaire (mêmes règles, même appel API) présenté en fenêtre, au format de
	// "Modification du compte", le type étant fixé par le filtre de l'onglet Comptes.
	asModal,
	onCancel,
	initialLabel,
}) {
	const [floorsSelected, setFloors] = useState(floors.map(f => f.id));
	const [newAccValue, setAccValue] = useState({
		analytics: '',
		label: initialLabel || '',
		accNumber: '',
		table_id: '',
	});
	// initialAccType : type présélectionné quand on arrive ici depuis le bouton "Nouveau" de la
	// modale des erreurs (ex. 'cashback'), sinon le type par défaut.
	const [selectedAccType, setSelectedAccType] = useState(
		initialAccType || 'product'
	);
	const [accountVatList, setAccountVatList] = useState(null);
	const [linkedCustomerAccounts, setLinkedCustomerAccounts] = useState([]);

	// Le type peut aussi changer après le montage (bascule depuis l'onglet Comptes sur un autre type).
	useEffect(() => {
		if (initialAccType) setSelectedAccType(initialAccType);
	}, [initialAccType]);

	useEffect(() => {
		getVatListAccounts();
	}, []);

	useEffect(() => {
		if (accountVatList && accountVatList['customer']) {
			const accounts = accountVatList['customer'].reduce((acc, a) => {
				if (a.linking) {
					acc.push(...a.linking.map(l => l.id_table));
				}
				return acc;
			}, []);
			setLinkedCustomerAccounts(accounts);
		}
	}, [accountVatList]);

	const fetcher = async (route, setter) => {
		try {
			const res = await CallApi('GET', route, '', '');

			if (res && res[0] && res[0].datas && setter) {
				return setter(res[0].datas);
			}
		} catch (error) {
			addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue',
				persistent: false,
			});
		}
	};
	const getVatListAccounts = async () => {
		await fetcher('exportVat/getVatAccounts', setAccountVatList);
	};

	const onSelectFloors = d => {
		const formattedFloors = d.map(f => f['id_floor']);

		setFloors(formattedFloors);
	};

	const onAccTypeSelected = d => {
		setSelectedAccType(d['value']);
	};

	const accType = ACCOUNT_TYPES.map((t, i) => ({
		id: i + 1,
		label: I18n.t('exportVat.account_type.' + t),
		value: t,
	}));

	if (cashbackPaymentTypes && cashbackPaymentTypes.length) {
		accType.push({
			id: accType.length,
			label: I18n.t('exportVat.account_type.cashback'),
			value: 'cashback',
		});
	}

	// Libellé du type courant : le sélecteur affichait toujours celui du premier type de la liste.
	const selectedAccTypeCurrent = accType.find(t => t.value === selectedAccType);
	const selectedAccTypeLabel = selectedAccTypeCurrent
		? selectedAccTypeCurrent.label
		: accType[0]['label'];

	const checkForm = _ => {
		if (selectedAccType == 'customer' && !newAccValue.table_id) return false;
		if (
			!newAccValue.label.trim() ||
			!newAccValue.accNumber.trim()
		)
			return false;

		return true;
	};

	const handleCreateAcc = async () => {
		if (!checkForm()) {
			alert('Tous les champs obligatoires ne sont pas renseignés');
			return;
		}

		try {
			const created = await CallApi('POST', 'exportVat/createVatAccounts', '', {
				type: selectedAccType,
				account_number: newAccValue.accNumber,
				label: newAccValue.label,
				analytics: newAccValue.analytics,
				all_floors:
					selectedAccType != 'product'
						? true
						: floorsSelected.length > 0 &&
						  floorsSelected.length === floors.length,
				floors: selectedAccType == 'product' ? floorsSelected : [],
				table_id: newAccValue.table_id,
			});

			setAccValue({
				analytics: 'Défaut',
				label: '',
				accNumber: '',
			});
			addFlashMessage({
				type: 'success',
				text: 'Votre compte comptable à bien été ajouté',
				persistent: false,
			});
			onCreate(selectedAccType, created && created[0] && created[0]._id);

			// addFlashMessage({
			// 	type: 'danger',
			// 	text: 'Une erreur est survenue',
			// 	persistent: false,
			// });
		} catch (error) {
			console.log(error);
		}
	};

	// useEffect(() => {
	// 	onSelectFloors(floors);
	// }, []);

	const setField = field => val =>
		setAccValue(newAccValue => ({ ...newAccValue, [field]: val }));

	if (asModal) {
		return (
			<Dialog id="modal-edit-account" onClose={onCancel} open={true}>
				<h2 className="account-edit-title">
					Création d'un compte {selectedAccTypeLabel}
				</h2>
				<DialogContent>
					{selectedAccType == 'product' ? (
						<div>
							<label>
								Salles :{' '}
								<Filters
									multiple={true}
									monoSelect={false}
									label="Toutes les salles"
									datas={JSON.parse(JSON.stringify(floors))}
									paramsLabel="name"
									paramsValue="id"
									selected={floorsSelected}
									onClose={(data, pValue) => {
										if (!!data) {
											onSelectFloors(data.map(f => ({ id_floor: f.id })));
										}
										return;
									}}
								/>
							</label>
						</div>
					) : null}
					<p>
						<label>Libellé du compte : </label>
						<CellEditable
							val={newAccValue.label}
							clsName="account-edit-input"
							onBlurFct={setField('label')}
							isLabel={true}
							autoFocus
						/>
					</p>
					<p>
						<label>N° du compte : </label>
						<CellEditable
							val={newAccValue.accNumber}
							clsName="account-edit-input"
							onBlurFct={setField('accNumber')}
							isLabel={true}
						/>
					</p>
					<p>
						<label>Libellé de l'écriture : </label>
						<CellEditable
							val={newAccValue.analytics}
							clsName="account-edit-input"
							onBlurFct={setField('analytics')}
							isLabel={true}
							placeholder="optionnel"
						/>
					</p>
					{selectedAccType == 'customer' ? (
						<p>
							<label>Compte client : </label>
							<select
								value={newAccValue.table_id}
								onChange={e => setField('table_id')(e.target.value)}>
								<option value="" disabled>
									Sélectionnez un compte
								</option>
								{contacts.map(c => (
									<option
										key={c.id}
										value={c.id}
										disabled={linkedCustomerAccounts.includes(c.id)}>
										{c.name} ({c.id})
									</option>
								))}
							</select>
						</p>
					) : null}
					{selectedAccType == 'achats' || selectedAccType == 'ventes' ? (
						<p>
							<label>Identifiant mouvement : </label>
							<CellEditable
								val={newAccValue.table_id}
								clsName="account-edit-input"
								onBlurFct={setField('table_id')}
								isLabel={true}
							/>
						</p>
					) : null}
				</DialogContent>
				<DialogActions>
					<Button color="primary" onClick={onCancel}>
						Annuler
					</Button>
					<Button variant="contained" color="primary" onClick={handleCreateAcc}>
						Ajouter
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	return (
		<div className="vat-settings-handler-container">
			<div className="vat-filter-list">
				<div className="keys-container">
					{' '}
					<span>Type : </span>
					<FiltersVat
						multiple={false}
						monoSelect={true}
						label={selectedAccTypeLabel}
						selected={[{ label: selectedAccTypeLabel, value: selectedAccType }]}
						datas={accType}
						paramsLabel="label"
						paramsValue="value"
						inputClassName="dataExport_filter_input"
						inputLabelClassName="dataExport_input_label"
						onClose={(data, pValue) => {
							if (!!data) {
								onAccTypeSelected(data);
							}

							return;
						}}
					/>
				</div>
			</div>

			{selectedAccType == 'product' ? (
				<div className="vat-filter-list">
					<div className="keys-container">
						<span>Salles : </span>
						<Filters
							multiple={true}
							monoSelect={false}
							label="Toutes les salles"
							datas={JSON.parse(JSON.stringify(floors))}
							paramsLabel="name"
							paramsValue="id"
							selected={floorsSelected}
							inputClassName="dataExport_filter_input"
							inputLabelClassName="dataExport_input_label"
							onClose={(data, pValue) => {
								if (!!data) {
									onSelectFloors(data.map(f => ({ id_floor: f.id })));
								}

								return;
							}}
						/>
					</div>
				</div>
			) : null}

			<div className="vat-settings-acc-product">
				<div className="keys-container">
					<span>Libellé du compte : </span>
					<CellEditable
						val={newAccValue.label}
						clsName="key-value"
						onBlurFct={val => {
							const newVal = { label: val };
							setAccValue(newAccValue => ({
								...newAccValue,
								...newVal,
							}));
						}}
						isLabel={true}
					/>
				</div>
				<div className="keys-container">
					<span>N° du compte : </span>
					<CellEditable
						val={newAccValue.accNumber}
						clsName="key-value"
						onBlurFct={val => {
							const newVal = { accNumber: val };
							setAccValue(newAccValue => ({
								...newAccValue,
								...newVal,
							}));
						}}
						isLabel={true}
					/>
				</div>
				<div className="keys-container">
					<span>Libellé de l'écriture (optionnel) : </span>
					<CellEditable
						val={newAccValue.analytics}
						clsName="key-value"
						onBlurFct={val => {
							const newVal = { analytics: val };
							setAccValue(newAccValue => ({
								...newAccValue,
								...newVal,
							}));
						}}
						isLabel={true}
					/>
				</div>

				{selectedAccType == 'customer' ? (
					<div className="vat-filter-list">
						<div className="keys-container">
							<span>Compte client : </span>
							<select
								value={newAccValue.table_id}
								onChange={e => {
									setAccValue(newAccValue => ({
										...newAccValue,
										table_id: e.target.value,
									}));

									return;
								}}>
								<option value="" disabled>
									Sélectionnez un compte
								</option>
								{contacts.map(c => {
									const disabled = linkedCustomerAccounts.includes(c.id);
									return (
										<option value={c.id} disabled={disabled}>
											{c.name} ({c.id})
										</option>
									);
								})}
							</select>
						</div>
					</div>
				) : null}

				{selectedAccType == 'achats' || selectedAccType == 'ventes' ? (
					<div className="keys-container">
						<span>Identifiant mouvement : </span>
						<CellEditable
							val={newAccValue.table_id}
							clsName="key-value"
							onBlurFct={val => {
								const newVal = { table_id: val };
								setAccValue(newAccValue => ({
									...newAccValue,
									...newVal,
								}));
							}}
							isLabel={true}
						/>
					</div>
				) : null}

				<div className="vat-account-handler-btn">
					<button
						className={`btn-vat-settings`}
						onClick={() => {
							handleCreateAcc();
						}}>
						Ajouter
					</button>
				</div>
				<Divider />
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return { user: state.auth.user };
}

export default connect(mapStateToProps, { addFlashMessage })(AccountsHandler);
